var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportErrorWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/danger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "danger"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 14.25V22.1667",
    stroke: "#FF852D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.0004 33.8998H9.40542C3.91126 33.8998 1.61542 29.9732 4.27542 25.1757L9.21542 16.2773L13.8704 7.91734C16.6888 2.83484 21.3121 2.83484 24.1304 7.91734L28.7854 16.2932L33.7254 25.1915C36.3854 29.989 34.0738 33.9157 28.5954 33.9157H19.0004V33.8998Z",
    stroke: "#FF852D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.9912 26.916H19.0054",
    stroke: "#FF852D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportErrorWarning);
export default __webpack_public_path__ + "static/media/reportErrorWarning.63a7345caa7330a66c16951c4ff35765.svg";
export { ForwardRef as ReactComponent };